import React from "react";
import Nav from "./nav";
// import ContactNav from "./contact-nav";
// import { motion } from "framer-motion";



class Header extends React.Component {

    render () {
        const links = [
            {id: 1, name: "home"},
            {id: 2, name: "shop"},
            {id: 3, name: "blog"}, 
            {id: 4, name: "about"}, 
            {id: 5, name: "contact"}
        ];

        return (
            <div className="header" id="header">
                {/* <ContactNav /> */}
                <Nav navLinks={ links }/>
                
                {
                    window.onscroll = () => {this.handleScroll()}
                }
            </div>
        )
    }

    handleScroll () {
        var navbar = document.getElementById("navigation");
        var sticky = navbar?.offsetTop;
        sticky = sticky - 1;
        
        if (window.pageYOffset > 0) {
            navbar?.classList.add("sticky")
            console.log(window.pageYOffset)
        }else {
            navbar?.classList.remove("sticky")
            console.log("scrolling...")
        }
    }
}

export default Header;